export default "__VITE_ASSET__e5_cGDb9__"